import mixpanel from 'mixpanel-browser';

export const trackPage = (eventName: string): void => {
  mixpanel.track(eventName);
};
